import { render, staticRenderFns } from "./buyTypeList copy.vue?vue&type=template&id=08089fbb&"
import script from "./buyTypeList copy.vue?vue&type=script&lang=js&"
export * from "./buyTypeList copy.vue?vue&type=script&lang=js&"
import style0 from "./buyTypeList copy.vue?vue&type=style&index=0&id=08089fbb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports